/**
 * Glifos do painel, um so componente (RNF15).
 *
 * Todos sao decorativos por padrao (`aria-hidden`): a informacao esta sempre no
 * texto ao lado. Quando um icone for o unico conteudo de um botao, o botao e
 * quem recebe `aria-label`. Tracos de 1.7 e cantos arredondados para casar com
 * os glifos que ja existiam nas paginas.
 */

export type IconName =
  | 'painel'
  | 'funil'
  | 'carrinho'
  | 'calendario'
  | 'relogio'
  | 'leads'
  | 'telefone'
  | 'whatsapp'
  | 'email'
  | 'disparo'
  | 'modelo'
  | 'config'
  | 'empresa'
  | 'comissao'
  | 'grafico'
  | 'check'
  | 'x'
  | 'mais'
  | 'busca'
  | 'filtro'
  | 'seta-esq'
  | 'seta-dir'
  | 'chevron'
  | 'externo'
  | 'atualizar'
  | 'play'
  | 'pausa'
  | 'lixeira'
  | 'editar'
  | 'copiar'
  | 'olho'
  | 'alerta'
  | 'info'
  | 'moeda'
  | 'usuarios'
  | 'clique'
  | 'resposta'
  | 'saida'
  | 'estrela'
  | 'link'
  | 'upload'
  | 'download'
  | 'robo'
  | 'raio'
  | 'escudo'
  | 'chave';

const PATHS: Readonly<Record<IconName, string>> = {
  painel: 'M3.75 4.5h6v6h-6zM14.25 4.5h6v3.75h-6zM14.25 12h6v7.5h-6zM3.75 14.25h6v5.25h-6z',
  funil: 'M4 5h16l-6 7v6l-4 2v-8L4 5Z',
  carrinho: 'M3.5 5h2l2.2 10h9.6l1.7-7H7M9.5 19h.01M16.5 19h.01',
  calendario: 'M3.75 5.25h16.5v15H3.75zM3.75 9.75h16.5M8.25 3v4.5M15.75 3v4.5',
  relogio: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM12 8v4l2.8 1.8',
  leads: 'M15.75 7.5a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.5 20.25a7.5 7.5 0 0 1 15 0',
  telefone: 'M5.5 4.5h3l1.5 4-2 1.5a9 9 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2 2A15 15 0 0 1 3.5 6.5a2 2 0 0 1 2-2Z',
  whatsapp: 'M12 3.5a8.5 8.5 0 0 0-7.3 12.9L3.5 20.5l4.2-1.1A8.5 8.5 0 1 0 12 3.5ZM9 8.5c.3 2.6 2.9 5.2 5.5 5.5l1-1.2-1.8-.9-.9.9c-1-.4-1.8-1.2-2.2-2.2l.9-.9-.9-1.8L9 8.5Z',
  email: 'M3.75 6.75h16.5v10.5H3.75zM3.75 7.5 12 13l8.25-5.5',
  disparo: 'M4 12 20 4l-4 16-4-6.5L4 12ZM12 13.5 20 4',
  modelo: 'M6 3.75h9l3 3v13.5H6zM15 3.75v3h3M9 12h6M9 15.5h6M9 8.5h3',
  config: 'M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4',
  empresa: 'M4 20.5V5.5l8-2.5v17.5M12 20.5h8v-10l-8-2M7.5 8.5h1M7.5 12h1M7.5 15.5h1M15.5 13.5h1M15.5 17h1M4 20.5h16',
  comissao: 'M6.5 3.5h11v17l-2.2-1.5-2.2 1.5-2.2-1.5-2.2 1.5-2.2-1.5V3.5ZM9.5 8h5M9.5 11.5h5M9.5 15h3',
  grafico: 'M4 20h16M6.5 16V10M11 16V6M15.5 16v-4M20 16V8',
  check: 'm5 12.5 4.5 4.5L19 7.5',
  x: 'M6 6l12 12M18 6 6 18',
  mais: 'M12 5v14M5 12h14',
  busca: 'M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM15.5 15.5 20 20',
  filtro: 'M4 6h16M7 12h10M10 18h4',
  'seta-esq': 'M19 12H5M11 6l-6 6 6 6',
  'seta-dir': 'M5 12h14M13 6l6 6-6 6',
  chevron: 'm6 9 6 6 6-6',
  externo: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  atualizar: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5',
  play: 'M7 5v14l11-7L7 5Z',
  pausa: 'M8 5v14M16 5v14',
  lixeira: 'M5 7h14M9 7V4.5h6V7M7 7l.8 12.5h8.4L17 7M10 11v5M14 11v5',
  editar: 'M4 20h4l11-11-4-4L4 16v4ZM13.5 6.5l4 4',
  copiar: 'M9 9h10v11H9zM5 15V4h10',
  olho: 'M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12ZM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z',
  alerta: 'M12 4 2.5 20h19L12 4ZM12 10v4M12 17v.5',
  info: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM12 11v5M12 8v.5',
  moeda: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM12 8v8M9.8 10.2c.4-.9 1.3-1.2 2.2-1.2 1.3 0 2.2.6 2.2 1.5 0 2-4.4 1-4.4 3 0 .9.9 1.5 2.2 1.5.9 0 1.8-.3 2.2-1.2',
  usuarios: 'M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.5 19a5.5 5.5 0 0 1 11 0M16 10.5a2.5 2.5 0 1 0 0-5M17.5 14.5a4.5 4.5 0 0 1 3 4.5',
  clique: 'M8 4v3M4 8h3M5.5 5.5 7 7M9 9l9 3.5-4 1.5-1.5 4L9 9Z',
  resposta: 'M4.5 6.5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H10l-4.5 3.5V16.5h-1a2 2 0 0 1 0-4v-6Z',
  saida: 'M14 5h5v14h-5M10 8l-4 4 4 4M6 12h9',
  estrela: 'm12 4 2.4 5 5.4.7-4 3.8 1 5.4L12 16.3 7.2 18.9l1-5.4-4-3.8L9.6 9 12 4Z',
  link: 'M10 14 14 10M8.5 15.5l-1.5 1.5a3 3 0 0 1-4.2-4.2L6 9.6a3 3 0 0 1 4.2 0M15.5 8.5 17 7a3 3 0 0 1 4.2 4.2L18 14.4a3 3 0 0 1-4.2 0',
  upload: 'M12 16V5M7.5 9.5 12 5l4.5 4.5M4.5 19.5h15',
  download: 'M12 5v11M7.5 11.5 12 16l4.5-4.5M4.5 19.5h15',
  robo: 'M5 9h14v10H5zM12 5v4M9 13h.01M15 13h.01M9.5 16.5h5M8 5h8',
  raio: 'M13 3 5 13.5h6L10 21l8-10.5h-6L13 3Z',
  escudo: 'M12 3.5 5 6v6c0 4 3 7.2 7 8.5 4-1.3 7-4.5 7-8.5V6l-7-2.5ZM9.5 12l2 2 3.5-4',
  chave: 'M15 4a5 5 0 1 0-4.6 6.9L4 17.3V20h2.7l1-1 1-1 1.4.1.1-1.4 1-1 1.1.1L13 14.4A5 5 0 0 0 15 4Zm0 3h.01',
};

const SIZE: Readonly<Record<'xs' | 'sm' | 'md' | 'lg', string>> = {
  xs: 'h-3.5 w-3.5',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export interface IconProps {
  readonly name: IconName;
  readonly size?: 'xs' | 'sm' | 'md' | 'lg';
  readonly className?: string;
  /** So quando o icone carrega informacao sozinho (raro). */
  readonly label?: string;
}

export function Icon({ name, size = 'sm', className = '', label }: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      className={`${SIZE[size]} shrink-0 ${className}`}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={label === undefined ? true : undefined}
      role={label === undefined ? undefined : 'img'}
      aria-label={label}
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
